import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from "../../../../environments/environment";
import { IResultKpiModel } from 'src/app/models/dashboard/kpi.model';
import { Observable } from 'rxjs';
import { IPatient } from 'src/app/models/patient/patient.model';
import {IResultPatientGap} from "../../../models/patient/patient-gap/patient-gap.model";
import {map} from "rxjs/operators";
import {IResultPatientRisk} from "../../../models/patient/patient-risk/patient-risk.model";

@Injectable({
  providedIn: 'root'
})
export class PatientHttpService {

  constructor(private http: HttpClient) {
  }
  getPatientPractice(patientId:string, practiceId:string):Observable<IPatient>{
    return this.http.get<IPatient>(`${environment.apiUrl}/catalog/patient/${patientId}/?practice_id=${practiceId}`);
  }
  getPatientGap(patientId: string):Observable<IResultPatientGap>{
    return this.http.get<IResultPatientGap>(`${environment.apiUrl}/catalog/patient_gap/?patient_id=${patientId}&ordering=complete,measure_code`);
  }
  getPatientRisk(patientId: string):Observable<IResultPatientRisk>{
    return this.http.get<IResultPatientRisk>(`${environment.apiUrl}/catalog/patient_pathology/?patient_id=${patientId}&ordering=present,code`);
  }
  getIAPatient(memberPlanId: string):Observable<any>{
    return this.http.get<any>(`${environment.apiUrl}/catalog/check_entity_code/call_ai_api/?code=${memberPlanId}&type=MPIAI`);
  }


  updateAppGap(id: number,providerId:string, practiceId: string): Observable<any> {
    const params = new URLSearchParams();
    params.append('practice_id', practiceId);

    if (providerId) {
      params.append('provider_id', providerId);
    }
    return this.http.post<any>(
      `${environment.apiUrl}/catalog/patient_gap/${id}/update_app/?${params.toString()}`,
      {}
    );
  }

  updateInactivePathology(id: number, practiceId: string, providerId?: string): Observable<any> {
    const params = new URLSearchParams();
    params.append('practice_id', practiceId);

    if (providerId) {
      params.append('provider_id', providerId);
    }
    return this.http.post<any>(`${environment.apiUrl}/catalog/patient_pathology/${id}/update_inactive/?${params.toString()}`,{});
  }

  updateAppPathology(id: number, practiceId: string, providerId?: string): Observable<any> {
    const params = new URLSearchParams();
    params.append('practice_id', practiceId);

    if (providerId) {
      params.append('provider_id', providerId);
    }
    return this.http.post<any>(`${environment.apiUrl}/catalog/patient_pathology/${id}/update_app/?${params.toString()}`,{});
  }

  addWalkIn(patientId: string, practiceId: string, providerId?: string): Observable<any> {
    const params = new URLSearchParams();
    params.append('practice_id', practiceId);

    if (providerId) {
      params.append('provider_id', providerId);
    }

    const url = `${environment.apiUrl}/catalog/patient/${patientId}/add_walk_in/?${params.toString()}`;

    return this.http.post<any>(url, {});
  }


  private buildParams(practiceId: string, scheduleId: string, providerId?: string): HttpParams {
    let params = new HttpParams()
      .set('practice_id', practiceId)
      .set('schedule_id', scheduleId);

    if (providerId) {
      params = params.set('provider_id', providerId);
    }

    return params;
  }

  updateNoShow(id: number, scheduleId: string, practiceId: string, providerId?: string): Observable<any> {
    const params = this.buildParams(practiceId, scheduleId, providerId);
    return this.http.post<any>(
      `${environment.apiUrl}/catalog/patient/${id}/update_no_show/?${params.toString()}`,
      {}

    );
  }

  updateVisit(id: number, scheduleId: string, practiceId: string, providerId?: string): Observable<any> {
    const params = this.buildParams(practiceId, scheduleId, providerId);
    return this.http.post<any>(
      `${environment.apiUrl}/catalog/patient/${id}/update_visit/?${params.toString()}`,
      {}

    );
  }
  canceledVisit(id: number, scheduleId: string, practiceId: string,providerId:string): Observable<any> {
    const params = this.buildParams(practiceId, scheduleId,providerId);
    return this.http.post<any>(
      `${environment.apiUrl}/catalog/patient/${id}/cancel_walkin/?${params.toString()}`,
      {}
    );
  }
}
